'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spinner = function (_PureComponent) {
  _inherits(Spinner, _PureComponent);

  function Spinner() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Spinner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call.apply(_ref, [this].concat(args))), _this), _this.getCurrentOffset = function () {
      var duration = _this.props.duration;

      return _this.el.getCurrentTime() % duration / duration;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Spinner, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.handleOffset && this.props.handleOffset(this.getCurrentOffset());
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var offset = this.props.offset;
      var duration = this.props.duration;

      offset %= 1;
      var begin = (1 - offset) * duration - duration;

      return _react2.default.createElement(
        'div',
        { className: 'spinner ' + this.props.className },
        _react2.default.createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            width: this.props.size + 'px',
            height: this.props.size + 'px',
            viewBox: '0 0 100 100',
            preserveAspectRatio: 'xMidYMid',
            className: 'uil-ring-alt',
            ref: function ref(el) {
              return _this2.el = el;
            } // eslint-disable-line no-return-assign
          },
          _react2.default.createElement('rect', { x: '0', y: '0', width: '100', height: '100', fill: 'none', className: 'bk' }),
          _react2.default.createElement('circle', { cx: '50', cy: '50', r: '40', stroke: _colors.alloy, fill: 'none', strokeWidth: '10', strokeLinecap: 'butt' }),
          _react2.default.createElement(
            'circle',
            { cx: '50', cy: '50', r: '40', stroke: _colors.info.darkest, fill: 'none', strokeWidth: '10', strokeLinecap: 'butt' },
            _react2.default.createElement('animate', {
              attributeName: 'stroke-dashoffset',
              dur: duration,
              repeatCount: 'indefinite',
              from: '0',
              to: '502',
              begin: begin
            }),
            _react2.default.createElement('animate', {
              attributeName: 'stroke-dasharray',
              dur: duration,
              repeatCount: 'indefinite',
              values: '75.3 175.7;1 250;75.3 175.7',
              begin: begin
            })
          )
        )
      );
    }
  }]);

  return Spinner;
}(_react.PureComponent);

exports.default = Spinner;


Spinner.propTypes = {
  className: _propTypes2.default.string,
  size: _propTypes2.default.number,
  duration: _propTypes2.default.number,
  offset: _propTypes2.default.number,
  handleOffset: _propTypes2.default.func
};

Spinner.defaultProps = {
  size: 76,
  className: '',
  duration: 2,
  offset: 0
};